export default "__VITE_ASSET__Dw6o_p0d__"